{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Skriv inn e-postadressen du bruker for å logge inn i kontaktsenteret, så sender vi deg instruksjoner for å tilbakestille passordet.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-post",
      "PLACEHOLDER": "Skriv inn din e-post.",
      "ERROR": "Vennligst skriv inn en gyldig e-postadresse."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link for å tilbakestille passordet ditt er sendt til e-postadressen din.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "SUBMIT": "Send"
  }
}
